module.exports = __webpack_public_path__ + "img/Weapon_158.d2d0aeb4.png";